var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"app",style:({ background: _vm.$vuetify.theme.themes[_vm.theme].background })},[_c('layout'),_c('alertDialog'),_c('confirmDialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }